// Золотой парашют (deus_parashyut, cost 10) — passive trigger.
// При розыгрыше встаёт «на защите». При смертельном уроне — HP=1, Иммунитет до конца хода.
// Логика срабатывания — в hero-damage.js.

import { chargeInfluence } from './influence.js';

export const CARD_ID = 'deus_parashyut';
export const COST = 10;

// Можно ли сыграть Парашют. Один Парашют активен одновременно.
export function canPlayParachute(state, playerIdx) {
  const p = state.players[playerIdx];
  if (p.influence < COST) return { ok: false, reason: 'not_enough_influence' };
  if (p.parachuteActive) return { ok: false, reason: 'already_active' };
  return { ok: true };
}

export function playParachute(state, playerIdx) {
  const can = canPlayParachute(state, playerIdx);
  if (!can.ok) return can;
  const p = state.players[playerIdx];
  const before = p.influence;
  if (!chargeInfluence(state, playerIdx, COST)) return { ok: false, reason: 'not_enough_influence' };
  p.parachuteActive = true;
  state.log.add(`🪂 ${p.name}: Золотой парашют активирован (Влияние ${before}→${p.influence})`);
  return { ok: true };
}
